import React from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

function Navbar({ toggleSidebar }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/signin', { replace: true });
  };

  const fullName = user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : 'Admin';
  const email = user ? user.email : '';

  return (
    <header className="ec-main-header" id="header">
      <nav className="navbar navbar-static-top navbar-expand-lg">
        <button id="sidebar-toggler" className="sidebar-toggle" onClick={toggleSidebar}></button>
        <div className="search-form d-lg-inline-block">
          <div className="input-group">
            <input type="text" name="query" id="search-input" className="form-control" placeholder="search.." autoFocus autoComplete="off" />
            <button type="button" name="search" id="search-btn" className="btn btn-flat">
              <i className="mdi mdi-magnify"></i>
            </button>
          </div>
          <div id="search-results-container">
            <ul id="search-results"></ul>
          </div>
        </div>
        <div className="navbar-right">
          <ul className="nav navbar-nav">
            <li className="dropdown user-menu">
              <button className="dropdown-toggle nav-link ec-drop" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="assets/img/user/user.png" className="user-image" alt="User" />
              </button>
              <ul className="dropdown-menu dropdown-menu-right ec-dropdown-menu">
                <li className="dropdown-header">
                  <img src="assets/img/user/user.png" className="img-circle" alt="User Image" />
                  <div className="d-inline-block">
                    {fullName} <small className="pt-1">{email}</small>
                  </div>
                </li>
                <li><a href="#" onClick={(e) => e.preventDefault()}><i className="mdi mdi-account"></i> My Profile</a></li>
                <li><a href="#" onClick={(e) => e.preventDefault()}><i className="mdi mdi-email"></i> Message</a></li>
                <li><a href="#" onClick={(e) => e.preventDefault()}> <i className="mdi mdi-diamond-stone"></i> Projects </a></li>
                <li className="right-sidebar-in"><a href="#" onClick={(e) => e.preventDefault()}> <i className="mdi mdi-settings-outline"></i> Setting </a></li>
                <li className="dropdown-footer">
                  <a href="#" onClick={handleLogout}> <i className="mdi mdi-logout"></i> Log Out </a>
                </li>
              </ul>
            </li>
            <li className="dropdown notifications-menu custom-dropdown">
              <button className="dropdown-toggle notify-toggler custom-dropdown-toggler">
                <i className="mdi mdi-bell-outline"></i>
              </button>
              <div className="card card-default dropdown-notify dropdown-menu-right mb-0">
                <div className="card-header card-header-border-bottom px-3">
                  <h2>Notifications</h2>
                </div>
                {/* ... (Notifications dropdown content here) */}
              </div>
            </li>
            <li className="right-sidebar-in right-sidebar-2-menu">
              <i className="mdi mdi-settings-outline mdi-spin"></i>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;